export const HeaderDrawerItems = () => {
	
	return <></>
}